import { render, staticRenderFns } from "./PrizeItem.vue?vue&type=template&id=0bc08d87&scoped=true&"
import script from "./PrizeItem.vue?vue&type=script&lang=js&"
export * from "./PrizeItem.vue?vue&type=script&lang=js&"
import style0 from "./PrizeItem.vue?vue&type=style&index=0&id=0bc08d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc08d87",
  null
  
)

export default component.exports